export default __webpack_public_path__ + "static/media/Feature4.e77f89d0.svg";